/* eslint-disable no-prototype-builtins */
import { actionTypes as coreActionTypes } from '../core';
import * as actionTypes from './actionTypes';
import { USER_STATUSES } from './constants';

const initialState = {
    users: {
        items: {},
        companies: {},
        logins: {
            items: {}
        }
    },
    activities: {
        items: {},
        users: {}
    },
    allUsers: {
        items: {},
        ids: [],
        pagination: {}
    },
    notifications: {
        items: {},
        users: {}
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_USERS.SUCCESS: {
            const { items, ids, companyId, pagination } = action.payload;
            return {
                ...state,
                users: {
                    ...state.users,
                    items,
                    companies: {
                        [companyId]: {
                            ids,
                            pagination
                        }
                    }
                }
            };
        }
        case actionTypes.LOGIN_AS_USER.SUCCESS: {
            const { userId, userData } = action.payload;
            return {
                ...state,
                users: {
                    ...state.users,
                    logins: {
                        ...state.users.logins,
                        items: {
                            [userId]: userData
                        }
                    }
                }
            };
        }
        case actionTypes.CLEAR_LOGIN_AS_USER: {
            return {
                ...state,
                users: {
                    ...state.users,
                    logins: {
                        items: {}
                    }
                }
            };
        }
        case actionTypes.UNBLOCK_USER.SUCCESS: {
            const { userId } = action.payload;
            return {
                ...state,
                users: {
                    ...state.users,
                    items: state.users.items.hasOwnProperty(userId)
                        ? {
                              ...state.users.items,
                              [userId]: {
                                  ...state.users.items[userId],
                                  status: USER_STATUSES.active
                              }
                          }
                        : state.users.items
                },
                allUsers: {
                    ...state.allUsers,
                    items: state.allUsers.items.hasOwnProperty(userId)
                        ? {
                              ...state.allUsers.items,
                              [userId]: {
                                  ...state.allUsers.items[userId],
                                  status: USER_STATUSES.active
                              }
                          }
                        : state.allUsers.items
                }
            };
        }
        case actionTypes.GET_USER_ACTIVITIES.SUCCESS: {
            const { items, ids, userId, pagination } = action.payload;
            return {
                ...state,
                activities: {
                    ...state.activities,
                    items,
                    users: {
                        [userId]: {
                            ids,
                            pagination
                        }
                    }
                }
            };
        }
        case actionTypes.GET_ALL_USERS.SUCCESS: {
            const { items, ids, pagination } = action.payload;
            return {
                ...state,
                allUsers: {
                    ...state.allUsers,
                    items,
                    ids,
                    pagination
                }
            };
        }
        case actionTypes.GET_USER_NOTIFICATIONS.SUCCESS: {
            const { items, ids, userId, pagination } = action.payload;
            return {
                ...state,
                notifications: {
                    ...state.notifications,
                    items,
                    users: {
                        [userId]: {
                            ids,
                            pagination
                        }
                    }
                }
            };
        }
        case actionTypes.UNLINK_COMRCE_OAUTH.SUCCESS: {
            const { userId } = action.payload;
            return {
                ...state,
                allUsers: {
                    ...state.allUsers,
                    items: {
                        ...state.allUsers.items,
                        [userId]: {
                            ...state.allUsers.items[userId],
                            comrceLinkedEmail: null
                        }
                    }
                }
            };
        }
        case actionTypes.DISABLE_TWO_FA.SUCCESS: {
            const { userId } = action.payload;
            return {
                ...state,
                allUsers: {
                    ...state.allUsers,
                    items: {
                        ...state.allUsers.items,
                        [userId]: {
                            ...state.allUsers.items[userId],
                            enable2FA: false
                        }
                    }
                }
            };
        }
        case coreActionTypes.RESET:
            return initialState;
        default:
            return state;
    }
};
